import React from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import ProgressiveImage from "../../Ui/ProgressiveImage/ProgressiveImage";
import heroPotato from "../../../images/The_1st_potato.png";

const Hero = ({ cities }) => {
  const { t } = useTranslation();

  return (
    <section
      className="sp-hero sp-section"
      style={{ paddingLeft: 32, paddingRight: 32 }}
    >
      <div
        className="sp-hero-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1.05fr 0.95fr",
          gap: 56,
          alignItems: "center",
          maxWidth: 1240,
          margin: "0 auto",
        }}
      >
      <div className="sp-hero-text">
        <div className="tag tag-accent" style={{ marginBottom: 18 }}>
          {t.landingHeroKicker}
        </div>
        <h1 style={{ maxWidth: 560 }}>{t.landingHeroTitle}</h1>
        <p style={{ fontSize: 17, maxWidth: 520, opacity: 0.85 }}>
          {t.landingHeroSubtitle}
        </p>
        <div
          style={{ display: "flex", gap: 24, flexWrap: "wrap", marginTop: 14 }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-accent-700)"
              strokeWidth="2.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="5" width="18" height="16" rx="3" />
              <path d="M3 10h18M8 3v4M16 3v4" />
            </svg>
            {t.landingHeroFeature1}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-accent-700)"
              strokeWidth="2.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 12 2.5a7 7 0 0 1 7 7C19 14.8 12 21 12 21Z" />
              <circle cx="12" cy="9.5" r="2.5" />
            </svg>
            {t.landingHeroFeature2}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-accent-700)"
              strokeWidth="2.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 12v9H4v-9M2 7h20v5H2zM12 7v14M12 7c-2-4-8-3-8 0s6 4 8 0zm0 0c2-4 8-3 8 0s-6 4-8 0z" />
            </svg>
            {t.landingHeroFeature3}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 14,
            marginTop: 22,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <a
            className="btn btn-primary"
            style={{ padding: "12px 26px", fontSize: 15 }}
            href="#explore"
          >
            {t.landingHeroCtaPrimary}
          </a>
          {false && (
            <div>
              <a
                className="btn btn-secondary"
                style={{ padding: "12px 26px", fontSize: 15 }}
                href="#tatoclub"
              >
                {t.landingHeroCtaSecondary}
              </a>
              {/* <div style={{ fontSize: 12, opacity: 0.6, marginTop: 6, textAlign: "center" }}>
                {t.landingHeroCtaSecondaryNote}
              </div> */}
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginTop: 24,
          }}
        ></div>
      </div>
      <div className="sp-hero-visual" style={{ position: "relative" }}>
        <div
          className="sp-hero-blob sp-hero-blob-1"
          style={{
            position: "absolute",
            top: -28,
            right: -28,
            width: 180,
            height: 180,
            borderRadius: "50%",
            background: "var(--color-accent-2-100)",
            zIndex: 0,
          }}
        />
        <div
          className="sp-hero-blob sp-hero-blob-2"
          style={{
            position: "absolute",
            bottom: -24,
            left: -20,
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: "var(--color-accent-100)",
            zIndex: 0,
          }}
        />
        <div
          className="sp-hero-photo"
          style={{
            width: "100%",
            height: 420,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            className="sp-hero-mascot"
            style={{ width: "92%", height: "92%", position: "relative" }}
          >
            <ProgressiveImage
              src={heroPotato}
              alt="Small Potatoes mascot"
              fill
              fit="contain"
              loading="eager"
              fetchPriority="high"
            />
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default Hero;
